import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  id: "resonant_ed_form",
  class: "w-full"
}
const _hoisted_2 = { class: "field" }
const _hoisted_3 = {
  key: 2,
  class: "p-error"
}
const _hoisted_4 = { class: "field" }
const _hoisted_5 = {
  key: 2,
  class: "p-error"
}
const _hoisted_6 = { class: "field" }

import { ref, computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import useVuelidate from '@vuelidate/core';
import { required, url } from '@vuelidate/validators';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Skeleton from 'primevue/skeleton';
import Message from 'primevue/message';
import { useRouting } from '@/composables';
import { useTenantIntegrationStore } from '@/store';

interface ResonantEdFormIntegration {
  id?: number;
  bearerToken: string;
  apiUrl: string;
}

const RESONANT_ED_PROVIDER_SLUG = 'screeners.resonant_ed';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResonantEd',
  setup(__props) {

const tenantIntegrationStore = useTenantIntegrationStore();

const { loading, error } = storeToRefs(tenantIntegrationStore);

const $routing = useRouting();

const rules = {
  bearerToken: { required },
  apiUrl: { required, url },
};

const payload = ref<ResonantEdFormIntegration>({
  bearerToken: '',
  apiUrl: 'https://resonant.resonanteducation.com',
});

const v$ = useVuelidate(rules, payload);

const originalForm = ref<ResonantEdFormIntegration | null>(null);

const tenantId = ref(Number($routing.route.params.id));

const integration = ref();

const isLoading = computed(() => loading.value);

onMounted(async () => await init());

const init = async () => {
  integration.value = tenantIntegrationStore.findIntegration(RESONANT_ED_PROVIDER_SLUG);

  if (integration.value) {
    payload.value = {
      id: integration.value.id,
      bearerToken: integration.value.data.bearer_token || '',
      apiUrl: integration.value.data.api_url || 'https://resonant.resonanteducation.com',
    };

    originalForm.value = { ...payload.value };
  }
};

const resetDirty = () => v$.value.$reset();

const fieldStyles = (key: string, styles?: string): string => {
  const validation = v$.value[key].$invalid && v$.value[key].$dirty ? 'p-invalid' : '';
  return `${styles} ${validation}`;
};

const onCancel = () => {
  if (originalForm.value) {
    payload.value = { ...originalForm.value };
  }
  v$.value.$reset();
};

const onSave = async () => {
  if (v$.value.$invalid) return;

  const formData = new FormData();
  const configData = JSON.stringify({
    bearer_token: payload.value.bearerToken,
    api_url: payload.value.apiUrl,
  });

  formData.append('data', configData);
  formData.append('integration_provider_type_slug', RESONANT_ED_PROVIDER_SLUG);

  payload.value.id
    ? await tenantIntegrationStore.updateTenantIntegration(tenantId.value, payload.value.id, formData)
    : await tenantIntegrationStore.saveTenantIntegration(tenantId.value, formData);

  if (!error.value) {
    await init();
    originalForm.value = { ...payload.value };
    resetDirty();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_FormCard = _resolveComponent("FormCard")!

  return (_openBlock(), _createBlock(_component_FormCard, {
    title: "Resonant Ed Screeners",
    dirty: _unref(v$).$anyDirty,
    cancel: onCancel,
    save: onSave,
    "save-disabled": _unref(v$).$anyDirty && _unref(v$).$invalid
  }, {
    form: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { for: "api-url" }, [
            _createTextVNode(" API URL "),
            _createElementVNode("span", { class: "text-red-500" }, "*")
          ], -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(_unref(Skeleton), {
                key: 0,
                height: "2.3rem"
              }))
            : (_openBlock(), _createBlock(_unref(InputText), {
                key: 1,
                id: "api-url",
                modelValue: _unref(v$).apiUrl.$model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).apiUrl.$model) = $event)),
                placeholder: "https://resonant.resonanteducation.com",
                class: _normalizeClass(fieldStyles('apiUrl', 'w-full')),
                onBlur: _unref(v$).apiUrl.$touch
              }, null, 8, ["modelValue", "class", "onBlur"])),
          (_unref(v$).apiUrl.$invalid && _unref(v$).apiUrl.$dirty)
            ? (_openBlock(), _createElementBlock("small", _hoisted_3, "A valid URL is required"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("label", { for: "bearer-token" }, [
            _createTextVNode(" Bearer Token "),
            _createElementVNode("span", { class: "text-red-500" }, "*")
          ], -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(_unref(Skeleton), {
                key: 0,
                height: "2.3rem"
              }))
            : (_openBlock(), _createBlock(_unref(Password), {
                key: 1,
                id: "bearer-token",
                modelValue: _unref(v$).bearerToken.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).bearerToken.$model) = $event)),
                placeholder: "Enter Bearer Token",
                class: _normalizeClass(fieldStyles('bearerToken', 'w-full')),
                feedback: false,
                "toggle-mask": "",
                onBlur: _unref(v$).bearerToken.$touch
              }, null, 8, ["modelValue", "class", "onBlur"])),
          (_unref(v$).bearerToken.$invalid && _unref(v$).bearerToken.$dirty)
            ? (_openBlock(), _createElementBlock("small", _hoisted_5, " Bearer Token is required "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(Message), {
            severity: "info",
            closable: false
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("p", { class: "text-sm" }, " The Bearer Token and API URL are used to authenticate with the Resonant Ed API. These credentials will be encrypted and stored securely. ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["dirty", "save-disabled"]))
}
}

})